import { BaseConfig, useConfig as hook } from '@eika-infrastruktur/config-provider';

import { defaultConfig } from './default-config-data';

interface Link {
    target?: string;
    text?: string;
    url: string;
}

export type ConfigLinks = {
    minside: Link;
    folgskade: Link;
    glasskadeverksted: Link;
    degogdinelandingsside: Link;
    dyrlandingsside: Link;
    husoghyttelandingsside: Link;
    innbolandingsside: Link;
    kjoretoylandingsside: Link;
    landbruklandingsside: Link;
    meldskadelandingsside: Link;
    naringlandingsside: Link;
    reiselandingsside: Link;
    rettshjelplandingsside: Link;
    ansvarlandingsside: Link;
    hundfirstvet: Link;
    kattfirstvet: Link;
    avtalebyttekeycloaklink: Link;
};
export type ConfigData = { readonly developerpageenabled: boolean };

export interface ConfigInterface extends BaseConfig {
    readonly bankregnr: string;
    readonly data: ConfigData;
    readonly links: ConfigLinks;
}

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof defaultConfig>();
